import { Component, h, Host, Element, Prop, State, Listen } from '@stencil/core';
import { translations } from './translations';
import { PexPriceFinderi18n, PexPriceFinderResponse } from './types';
import { PEX_truck } from 'pn-design-assets/pn-assets/illustrations.js';

@Component({
  tag: 'pn-pex-pricefinder',
  styleUrl: 'pn-pex-pricefinder.scss',
})
export class PnPexPricefinder {
  @Element() hostElement: HTMLElement;
  /** Specifies which language we want to show component in (sv,da,fi,no,en) */
  @Prop() language: string = 'sv';
  /** Currency (Kr, €)*/
  @Prop() currency: string = 'Kr';
  /** API Url */
  @Prop() apiUrl: string = '/api/pex/order';

  @State() i18n: PexPriceFinderi18n = translations.sv;

  @State() fromzip: number = null;
  @State() tozip: number = null;
  @State() weight: number = 1;

  @State() when: string = '';

  @State() response: PexPriceFinderResponse = null;

  componentWillLoad() {
    this.init();
  }

  async init() {
    this.setInitialTime();
    this.checkParameters();
    this.setLanguage();
  }

  setInitialTime() {
    const initialTime = new Date();
    initialTime.setHours(initialTime.getHours() + 1);
    initialTime.setMinutes(0);
    const splitTime = initialTime.toLocaleString('sv', { timeZoneName: 'short' }).split(' ');
    this.when = `${splitTime[0]}T${splitTime[1].substring(0, 5)}`;
  }

  checkParameters() {
    const params = new URLSearchParams(window.location.href);
    if (!params) {
      return;
    }
    const paramKeys = ['fromzip', 'tozip', 'weight', 'when'];
    paramKeys.forEach(key => {
      if (params.get(key)) {
        this[key] = params.get(key);
      }
    });
  }

  @Listen('language')
  setLanguage() {
    if (translations[this.language]) {
      this.i18n = translations[this.language] as PexPriceFinderi18n;
    }
  }

  onSubmit(e) {
    e.preventDefault();
    const formData = new FormData(e.target);
    const requestQuery = this.compileRequestQuery(formData);
    this.fetchResult(requestQuery);
  }

  compileRequestQuery(formData: FormData) {
    let query = {
      from: formData.get('fromzip'),
      to: formData.get('tozip'),
      weight: formData.get('weight'),
      when: formData.get('when'),
    };
    if (!query.when) {
      query.when = (this.hostElement.querySelector('input.date-input') as HTMLInputElement).value;
    }
    if (!formData.get('fromzip') || !formData.get('tozip') || !formData.get('weight')) {
      console.error('Form data is not compliant');
      return;
    }
    return query;
  }

  async fetchResult(query: any) {
    this.response = null;
    const params = new URLSearchParams(query);
    const req = await fetch(`${this.apiUrl}?${params.toString()}`, {
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
      },
    }).catch(this.onFetchError.bind(this));
    let response = await req.json().catch(this.onFetchError.bind(this));
    if (!response) {
      response = await (await import('./mockresponse.json')).default;
    }
    if (response) {
      this.response = response as PexPriceFinderResponse;
    }
  }

  onFetchError(error) {
    console.error('onFetchError(error', error);
  }

  render() {
    return (
      <Host>
        <div class="pex-pricefinder-top">
          <pn-illustration illustration={PEX_truck} />
          <h2>{this.i18n.heading}</h2>
        </div>
        <form method="get" action="" class="pex-pricefinder-form" onSubmit={this.onSubmit.bind(this)}>
          <fieldset>
            <div>
              <pn-input type="number" label={this.i18n.labelFrom} inputid="fromzip" name="fromzip" placeholder={this.i18n.zipPlaceholder} required value={this.fromzip}></pn-input>
              <pn-input type="number" label={this.i18n.labelTo} inputid="tozip" name="tozip" placeholder={this.i18n.zipPlaceholder} required value={this.tozip}></pn-input>
            </div>
          </fieldset>
          <fieldset>
            <div>
              <pn-input
                type="number"
                label={this.i18n.labelWeight}
                inputid="weight"
                name="weight"
                placeholder={this.i18n.weightPlaceholder}
                required
                value={this.weight}
              ></pn-input>
              <div class="datepicker">
                <label htmlFor="when">{this.i18n.labelWhen}</label>
                <pn-marketweb-input inputid="when" name="when" type="datetime-local" min={new Date().toISOString().split('T')[0]} value={this.when}></pn-marketweb-input>
              </div>
            </div>
          </fieldset>
          <fieldset>
            <div>
              <pn-button type="submit">{this.i18n.submitButtonText}</pn-button>
            </div>
          </fieldset>
        </form>
        {this.response ? (
          <div class="pex-pricefinder-response">
            <strong>
              {this.response.data.value} {this.currency}
            </strong>
          </div>
        ) : null}
      </Host>
    );
  }
}
